<template>
  <div class="OTP">
    <v-container>
      <div class="text-center incenter-logo">
        <a href="/">
          <v-img
            src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/smartclub247_512x512"
            height="100"
            width="200"
            class="mx-auto"
          ></v-img>
        </a>
      </div>
      <v-card raised class="mx-auto" max-width="344">
        <div class="my-5 text-center">
          <span>Kode OTP Telah dikirim ke</span>
          <div>
            <b>{{ words }}</b>
          </div>
          <div class="pa-5">
            <v-form ref="OTP" v-model="valid" lazy-validation="">
              <v-text-field
                v-model="kodeOTP"
                type="number"
                label="Kode OTP"
              ></v-text-field>
            </v-form>
            <div>
              Tidak menerima kode OTP ?
              <v-btn @click="reqOtp()" text block color="deep-purple accent-4">
                Kirim Ulang
              </v-btn>
            </div>
          </div>
        </div>

        <v-card-actions>
          <v-btn text block color="deep-purple accent-4">
            Lanjutkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog v-model="overlay" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      words: this.$route.params.hp,
      kodeOTP: null,
      valid: true,
      overlay: false,
    };
  },
  methods: {
    reqOtp() {
      this.overlay = true;

      fetch(
        "http://saebo.technology/apisms/capi/regis/" + this.words + "/incenter"
      ).then((response) => {
        this.overlay = false;
        Swal.fire(
          "Berhasil!",
          "Kode OTP sudah terkirim, Periksa Kembali HP Anda!",
          "success"
        );
        response.json();
      });
    },
    otpVerifikasi() {
      this.overlay = true;
      fetch(
        "http://saebo.technology/apisms/capi/cek/" +
          this.words +
          "/" +
          this.kodeOTP
      )
        .then((response) => response.json())
        .then((data) => {
          if (data == "success") {
            this.overlay = false;
            localStorage.setItem("user_id", "12");
            Swal.fire("Good job!", "Verifikasi berhasil !", "success");
            this.$router.push("success");
          }
        });
    },
  },
};
</script>
<style scoped></style>
